module.exports = __webpack_public_path__ + "static/image/service/gift.ver2_0_2.jpg?9e228db1";